import { render, staticRenderFns } from "./FomsMode.vue?vue&type=template&id=0373706a&scoped=true"
import script from "./FomsMode.vue?vue&type=script&lang=js"
export * from "./FomsMode.vue?vue&type=script&lang=js"
import style0 from "./FomsMode.vue?vue&type=style&index=0&id=0373706a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373706a",
  null
  
)

export default component.exports